import { z } from 'zod';

export const createVideoSchema = z.object({
  title: z.string().min(1, 'Title is required').max(255, 'Title must be less than 255 characters'),
  description: z.string().min(1, 'Description is required'),
  content: z.string().min(1, 'Content is required'),
  duration: z.string().min(1, 'Duration is required'),
  video_url: z.url('Invalid video URL'),
  learning_objectives: z.string().min(1, 'Learning objectives are required'),
  prerequisites: z.string().min(1, 'Prerequisites are required'),
  image_url: z.string().optional(),
  image: z.instanceof(File).optional(),
});

export type CreateVideoPayload = z.infer<typeof createVideoSchema>;
